import { render, staticRenderFns } from "./BatchModifySimCards.vue?vue&type=template&id=2049e1b1&scoped=true&"
import script from "./BatchModifySimCards.vue?vue&type=script&lang=js&"
export * from "./BatchModifySimCards.vue?vue&type=script&lang=js&"
import style0 from "./BatchModifySimCards.vue?vue&type=style&index=0&id=2049e1b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2049e1b1",
  null
  
)

export default component.exports